import React, { createContext, useContext, useState } from "react";
import fr from "../locales/fr";
import en from "../locales/en";

const translations = { fr, en };

const LanguageContext = createContext();

function getNestedValue(obj, path) {
  return path.split(".").reduce((curr, key) => curr?.[key], obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("voyage-r-lang") || "fr");

  const t = (path, vars = {}) => {
    let str = getNestedValue(translations[lang], path);
    if (str === undefined || str === null) {
      str = getNestedValue(translations.fr, path);
    }
    if (typeof str !== "string") return path;
    Object.entries(vars).forEach(([k, v]) => {
      str = str.replace(`{${k}}`, v);
    });
    return str;
  };

  const tArr = (path) => {
    const result = getNestedValue(translations[lang], path);
    if (Array.isArray(result)) return result;
    const fallback = getNestedValue(translations.fr, path);
    return Array.isArray(fallback) ? fallback : [];
  };

  const toggleLang = () => {
    const next = lang === "fr" ? "en" : "fr";
    setLang(next);
    localStorage.setItem("voyage-r-lang", next);
  };

  return (
    <LanguageContext.Provider value={{ lang, t, tArr, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
